require('./SettingModal.scss');

const React = require('react'),
    AppActionCreators = require('actions/AppActionCreators'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    {FlatButton} = require('material-ui'),
    {delay} = require('lodash/function'),
    SettingModalTabGeneral = require('./SettingModalTabGeneral/SettingModalTabGeneral'),
    LocaleServiceImpl = require('services/LocaleServiceImpl'),
    CustomModal = require('components/Commons/CustomModal/CustomModal'),
    {PropTypes} = require('react'),
    Notification = require('components/Notification/Notification');


const originalState = {
    codeCurrency: SessionStore.getCurrentCurrency(),
    codeCountry: SessionStore.getCurrentCountry()
};

const SettingModal = React.createClass({displayName: "SettingModal",

    propTypes: {
        isOpen: PropTypes.bool,
        onClose: PropTypes.func
    },

    _modalEl: null,

    getInitialState() {
        return originalState;
    },

    onChangeSettings(nextState) {
        this.setState(prevState => {
            return Object.assign(prevState, nextState);
        });
    },

    _saveAndClose() {
        const {
            isVisibleBrewingSection,
            isVisibleFermentingSection,
            isVisiblePackagingSection,
            email
        } = this.state;
        
        const validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (email.match(validRegex)) {
            if(this.state.resultEmail){
                if (!isVisibleBrewingSection && !isVisibleFermentingSection && !isVisiblePackagingSection) {
                    Notification.show(t('setting_modal_all_section_disable_error'), 'error');
                } else {
                    LocaleServiceImpl.saveSettingModal(this.state, () => {
                        Notification.show(t('dashboard_notification_reseting_browser'), 'info');
                        delay(() => {
                            AppActionCreators.saveSettingModal();
                        }, 1999);
                    });
                    this._close();
                }
             } else {
                Notification.show(t('setting_modal_general_email_in_use'), 'error');
            }
        } else {
            Notification.show(t('setting_modal_general_email_invalid'), 'error');
        }
    },

    _close() {
        this.props.onClose();
    },

    _getContentEl() {
        return (
            React.createElement("div", {className: "bp-custom-modal__content bp-setting-modal"}, 
                React.createElement(SettingModalTabGeneral, {
                    onChangeSettings: this.onChangeSettings, 
                    resultEmail: this.state.resultEmail}
                )
            )
        );
    },

    _getActionsModal() {
        return [
            React.createElement(FlatButton, {
                style: {'display': SessionStore.isAdminUser() ? 'inline' : 'none'}, 
                label: t('button_label_save'), 
                primary: true, 
                onTouchTap: this._saveAndClose
            }
            ),
            React.createElement(FlatButton, {
                label: t('button_label_cancel'), 
                onTouchTap: this._close
            }
            )
        ];
    },

    render() {
        const {isOpen} = this.props;

        if (!isOpen) {
            return null;
        }

        const actionsEl = this._getActionsModal();
        const contentEl = this._getContentEl();


        return (
            React.createElement(CustomModal, {
                customClass: "bp-setting-modal", 
                actions: actionsEl, 
                title: t('dashboard_menu_settings'), 
                isVisible: isOpen
            }, 
                contentEl
            )
        );
    }
});

module.exports = SettingModal;



/** WEBPACK FOOTER **
 ** ./src/components/Header/SettingModal/SettingModal.js
 **/